import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { JsaPhoto } from '../state-man/models/jsa-photo.model';
import { PhotoService } from './photo.service';
import { Jsa, JsaForm } from '../state-man/models/jsa.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})

export class JsaService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
    ) {
  }

  public async getScheduled () : Promise<Jsa[] | null> {   
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'jsa/scheduled/')        
      return (ret && Array.isArray(ret)) ? Jsa.buildMany(ret) : null      
    } catch (error) {
      LoggerService.log(error + 'jsa/scheduled/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }    
  }  

  public async getJsaForms() : Promise<JsaForm[] | null> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'jsa/scheduled/jsa_form/')
      return (ret && Array.isArray(ret)) ? JsaForm.buildMany(ret) : null
    } catch (error) {
      LoggerService.log(error + 'jsa/jsa_form/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }
  }

  public async sendJsaPhoto(photo_id: number) : Promise<any | null> {
      console.log('sendJsaPhoto', photo_id);
      try {
      return await this.apiService.apiReturnsAny('put', 'jsa/send_photo/' + photo_id).then(async () => {
          await this.uiService.showToast('Photo has been successfully Sent.', 'ok');
      });
      } catch (error) {
      LoggerService.log(error + 'jsa/send_photo/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.');
      return null
      }
  };

  public async sendJsaForm(form_id: number) : Promise<any | null> {
      try {
          return await this.apiService.apiReturnsAny('put', 'jsa/send_form/' + form_id).then(async () => {
              await this.uiService.showToast('Form has been successfully Sent.', 'ok');
          });
      }
      catch (error) {
          LoggerService.log(error + 'jsa/send_form/')
          await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')
          return null
      }
  };


  public async getPhotosByJsaId (jsa_id: number) : Promise<JsaPhoto[] | null> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'jsa_photo/jsa/' + jsa_id)          
      return (ret && Array.isArray(ret)) ? JsaPhoto.buildMany(ret) : null
    } catch (error) {
      LoggerService.log(error + 'jsa_photo/jsa/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }
  }

  public async getPhotoById (id: number) : Promise<JsaPhoto | null> {   
    try {
      const ret = await await this.apiService.apiReturnsAny('get', 'jsa_photo/' + id)          
      return (ret && Array.isArray(ret)) ? JsaPhoto.buildOne(ret) : null
    } catch (error) {
      LoggerService.log(error + 'jsa_photo/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }
  }

  public async addPhoto (jsa: Jsa, photo: JsaPhoto) : Promise<JsaPhoto | null> {
    try {
      const body = new FormData()
      const base64Image = photo.base64_sz.split(';base64,').pop()
      const blob = PhotoService.b64toBlob(base64Image, photo.file_type)
      body.append('media_file', blob, 'media_file')
      body.append('remove_bg', jsa.type === 'JSA' ? '1' : '0')
      body.append('is_completed', jsa.type === 'JSA' ? '1' : '0')
      body.append('created_at', photo.created_at)
      return await this.apiService.apiReturnsAny('post', '/jsa/media/' + jsa.id, body, 'multipart/form-data')          
    } catch (error) {
      LoggerService.log(error + '/jsa/media/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }
  }

  public async deletePhoto(photo: JsaPhoto) : Promise<any | null> {
    try {
      return await this.apiService.apiReturnsAny('delete', '/jsa_photo/' + photo.id)
    } catch (error) {
      LoggerService.log(error + 'delete /jsa_photo/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }    
  }

  public async addJsaForm(jsaForm: JsaForm) : Promise<JsaForm | null> {
    try {
      const body = jsaForm      
      return await this.apiService.apiReturnsAny('post', '/jsa/jsa_form/', body, 'application/json')   
    } 
    catch (error) {
      LoggerService.log(error + 'post jsa_form/')   
      await this.uiService.showToast('An unexpected error occurred adding the JSA Form and has been sent to the support team.')    
      return null
    }    
  }

  public async updateJsaForm(jsaForm: JsaForm) : Promise<JsaForm | null> {
    try {
      const body = jsaForm
      const ret = await this.apiService.apiReturnsAny('put', '/jsa/jsa_form/' + jsaForm.id, body, 'application/json')         
      return ret
    } catch (error) {
      LoggerService.log(error + 'put jsa_form/')   
      await this.uiService.showToast('An unexpected error occurred updating the JSA Form and has been sent to the support team.')    
      return null
    }  
  }

  public async deleteJsaForm(jsaForm: JsaForm) : Promise<any | null> {
    try {
      const body = jsaForm
      return await this.apiService.apiReturnsAny('delete', '/jsa/jsa_form/' + jsaForm.id, body, 'application/json')
    } catch (error) {
      LoggerService.log(error + 'delete jsa_form/')   
      await this.uiService.showToast('An unexpected error occurred deleting the JSA Form and has been sent to the support team.')    
      return null
    }
  }

}
